export enum Context {
  facets = 'facets',
  listings = 'listings',
  minilist = 'minilist',
}
// export type Context = 'facets' | 'listings' | 'minilist';
